"use client"

import { toast } from "@/components/ui/toast"

// Shared session-scoped store of emails that have subscribed this session.
// Used by BOTH the hub sidebar SubscribeForm and the site-wide Newsletter
// section so a user can't subscribe the same email twice (across either form).
const subscribed = new Set<string>()

const normalize = (email: string) => email.trim().toLowerCase()

/**
 * Returns true if this email is new and was recorded as subscribed.
 * Returns false if the email was already on the list (no-op, no duplicate).
 */
export function recordSubscription(email: string): boolean {
  const key = normalize(email)
  if (subscribed.has(key)) return false
  subscribed.add(key)
  return true
}

export function isSubscribed(email: string): boolean {
  return subscribed.has(normalize(email))
}

/**
 * Handle a subscribe submission: de-duplicates by email and fires the
 * appropriate toast. Returns true if it was a fresh subscription.
 */
export function handleSubscribe(rawEmail: string): boolean {
  const email = rawEmail.trim()
  if (!email) return false

  if (recordSubscription(email)) {
    toast({
      variant: "violet",
      title: "You're on the list!",
      description: `A confirmation will be sent to ${email} shortly.`,
    })
    return true
  }

  toast({
    variant: "violet",
    title: "Already subscribed",
    description: `${email} is on our list — we'll be in touch.`,
  })
  return false
}
